import moment from 'moment';
import { defaultFormat } from 'utils/date-field/formatter';
import { Range } from '../projects-report/common/range-picker/types';
export const getValueFromDateRangeForTimeAnalytics = (range, calendarEngine)=>{
    const { startDate, endDate } = calendarEngine.getValueFromDateRange(range);
    // Week ranges are Monday–Sunday via the calendar engine; other Range
    // values use the engine's default start/end for the selected type.
    if (range.type === Range.ThisWeek) {
        return [
            calendarEngine.getWeekStart(moment()),
            calendarEngine.getWeekEnd(moment())
        ];
    }
    if (range.type === Range.LastWeek) {
        const lastWeek = moment().subtract(1, 'week');
        return [
            calendarEngine.getWeekStart(lastWeek),
            calendarEngine.getWeekEnd(lastWeek)
        ];
    }
    return [
        startDate,
        endDate
    ];
};
export const getFormattedDateRangeForTimeAnalytics = (range, calendarEngine)=>{
    if (range.type === Range.Overall) {
        return [
            '',
            ''
        ];
    }
    const [startDate, endDate] = getValueFromDateRangeForTimeAnalytics(range, calendarEngine);
    return [
        defaultFormat(startDate),
        defaultFormat(endDate)
    ];
};
